module.exports = __webpack_public_path__ + "static/media/get-report.05c7e73f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/get-report.png
// module id = 1671
// module chunks = 0